const STATIONS = [
  { name: '古贤水文站', lng: 110.4518, lat: 36.0662 },
  { name: '龙门水文站', lng: 110.542, lat: 35.632 },
  { name: '龙潭水文站', lng: 108.8780, lat: 34.9037 },
  { name: '东庄水文站', lng: 108.4994, lat: 34.7379 },
  { name: '薛峰水文站', lng: 110.3093, lat: 35.5265 },
  { name: '张家卯监测点', lng: 109.5600, lat: 34.6474 },
  { name: '河口庙监测点', lng: 109.8500, lat: 35.3800 },
  { name: '宜川监测点', lng: 110.1754, lat: 36.0564 },
  { name: '韩城监测点', lng: 110.4428, lat: 35.4768 },
]

const WATER_POINTS = [
  { name: '古贤取水口', lng: 110.4522, lat: 36.0658 },
  { name: '调蓄水库北区', lng: 110.32, lat: 35.53 },
  { name: '输水渠道三号段', lng: 109.86, lat: 35.40 },
  { name: '调蓄水库东区', lng: 109.56, lat: 34.65 },
]

export class WarningService {
  constructor() {
    this._active = false
    this._timer = null
    this._interval = 8000
    this._callbacks = []
    this._lastFlyTime = 0
    this._flyCooldown = 15000
    this._lastEmitByKey = {}
    this._emitCooldown = 180000
  }

  onWarning(cb) {
    this._callbacks.push(cb)
    return () => { this._callbacks = this._callbacks.filter(c => c !== cb) }
  }

  _emit(type, data) {
    for (const cb of this._callbacks) cb({ type, data })
  }

  _shouldEmit(key, level) {
    const now = Date.now()
    const last = this._lastEmitByKey[key]
    if (!last) {
      this._lastEmitByKey[key] = { time: now, level }
      return true
    }
    const levelRank = { blue: 0, yellow: 1, orange: 2, red: 3 }
    const upgraded = (levelRank[level] || 0) > (levelRank[last.level] || 0)
    if (upgraded || now - last.time > this._emitCooldown) {
      this._lastEmitByKey[key] = { time: now, level }
      return true
    }
    return false
  }

  start() {
    if (this._active) return
    this._active = true
    this._tick()
    this._timer = setInterval(() => this._tick(), this._interval)
  }

  stop() {
    this._active = false
    if (this._timer) { clearInterval(this._timer); this._timer = null }
  }

  _tick() {
    this._checkRainfall()
    this._checkWaterQuality()
  }

  _checkRainfall() {
    const alerts = []
    for (const s of STATIONS) {
      const baseRain = Math.floor(Math.random() * 65)
      const burst = Math.random() > 0.92 ? Math.floor(30 + Math.random() * 45) : 0
      const rain = baseRain + burst
      if (rain >= 90) {
        alerts.push({ station: s.name, rain, lng: s.lng, lat: s.lat, level: rain >= 110 ? 'red' : 'orange', time: new Date().toLocaleString('zh-CN') })
      }
    }
    if (alerts.length > 0) {
      for (const a of alerts) {
        if (this._shouldEmit(`rain:${a.station}`, a.level)) {
          this._emit('rainfall_alert', { ...a, doFly: false })
        }
      }
    }
  }

  _checkWaterQuality() {
    const alerts = []
    for (const pt of WATER_POINTS) {
      const ntu = Math.floor(8 + Math.random() * 55)
      if (ntu >= 50) {
        alerts.push({ point: pt.name, lng: pt.lng, lat: pt.lat, ntu, level: ntu >= 70 ? 'red' : 'orange', time: new Date().toLocaleString('zh-CN') })
      }
    }
    for (const a of alerts) {
      if (this._shouldEmit(`water:${a.point}`, a.level)) this._emit('water_quality_alert', a)
    }
  }

  getSimulatedRainfallData() {
    return STATIONS.map(s => ({
      name: s.name,
      rain: 15 + Math.floor(Math.random() * 95),
      date: new Date().toLocaleDateString('zh-CN'),
      lng: s.lng,
      lat: s.lat,
    }))
  }

  getSimulatedWaterQuality() {
    return WATER_POINTS.map(pt => ({
      name: pt.name,
      section: pt.name.includes('水库') ? '调蓄水库' : pt.name.includes('渠道') ? '输水渠道' : '取水口',
      ph: (6.5 + Math.random() * 2.5).toFixed(2),
      ntu: Math.floor(5 + Math.random() * 60),
      do: (2.0 + Math.random() * 5).toFixed(1),
      level: 'blue',
      lng: pt.lng,
      lat: pt.lat,
    })).map(item => {
      if (item.ntu >= 50) item.level = 'red'
      else if (item.ntu >= 30) item.level = 'orange'
      else if (item.ntu >= 15) item.level = 'yellow'
      return item
    })
  }
}
